import React from "react";
import Blog1 from "./Blog1";
import Blog2 from "./Blog2";
import Blog3 from "./Blog3";
import Blog4 from "./Blog4";
import Blog5 from "./Blog5";
import Blog6 from "./Blog6";

const Blogs = () => {
  return (
    <div className="">
      <Blog1 />
      <Blog2 />
      <Blog3 />
      <Blog4 />
      <Blog5 />
      <Blog6 />
    </div>
  );
};

export default Blogs;
